










































import Vue from 'vue'
import UiCard from '@/components/UiCard.vue'
import UiButton from '@/components/UiButton.vue'
import UiIcon from '@/components/UiIcon.vue'
import AppFooter from '@/components/AppFooter.vue'

export default Vue.extend({
  name: 'Home',
  data(){
    return {
      orgId: "",
      localOrganizationId: localStorage.getItem('organizationId'),
      localOrganizationLogo: localStorage.getItem('organizationLogo'),
      localOrganizationName: localStorage.getItem('organizationName'),
    }
  },
  components: {
    UiCard,
    UiButton,
    UiIcon,
    AppFooter
  },
  computed: {
    organization(){
      return this.$store.getters.organization
    },
    errorType(){
      return this.$route.query.err
    }
  },
  methods: {
    isOrganizationPresent(){
      return this.organization.id && this.organization.brand && this.organization.brand.name
    },
    isLocalOrganizationPresent(){
      return this.localOrganizationId && this.localOrganizationLogo && this.localOrganizationName
    },
    handleSubmitOrgId(){
      if(!this.orgId) return
      this.$router.push({ name: 'OrganizationFeed', params: { organizationId: this.orgId.toLowerCase().trim() }})
    }
  }
})
